var render = function () {
  var _vm$modalData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.items.length > 0 ? _c('div', {
    staticClass: "text-left mt-4 rounded-lg border-gray-200 border-b border-t border-r border-l mb-3"
  }, [_c('Table', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.items,
      "row-key": ['id', 'order_number', 'final_amount', 'order_status', 'paymentgateway_id', 'is_renewal', 'client_id', 'is_active', 'created'],
      "current-page": _vm.currentPage,
      "isLoading": _vm.isLoading,
      "per-page": 15
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('router-link', {
          staticClass: "text-gray-500 no-underline hover:no-underline hover:bg-transparent",
          attrs: {
            "to": {
              path: '/order/detail?orderid=' + row.id
            }
          }
        }, [_vm._v(" " + _vm._s(row.id) + " ")])];
      }
    }, {
      key: "header-create",
      fn: function (_ref2) {
        var column = _ref2.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "actions",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('svg', {
          staticClass: "w-6 h-6 text-gray-500 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          },
          on: {
            "click": function ($event) {
              return _vm.openModal(row);
            }
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-width": "2",
            "d": "M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
          }
        }), _c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-width": "2",
            "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          }
        })])];
      }
    }, {
      key: "final_amount",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(row.final_amount, row.currency_code)) + " ")];
      }
    }, {
      key: "order_status",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('paymentview', {
          attrs: {
            "payment": row.order_status
          }
        })];
      }
    }, {
      key: "paymentgateway_id",
      fn: function (_ref6) {
        var row = _ref6.row;
        return [_c('gatewayview', {
          attrs: {
            "gateway": row.paymentgateway_id
          }
        })];
      }
    }, {
      key: "is_renewal",
      fn: function (_ref7) {
        var value = _ref7.value;
        return [value ? _c('span', [_vm._v(" Renewal ")]) : _c('span', [_vm._v(" Non-Renewal ")])];
      }
    }, {
      key: "client_id",
      fn: function (_ref8) {
        var row = _ref8.row;
        return [_c('Client', {
          attrs: {
            "client": row.client_id
          }
        })];
      }
    }, {
      key: "is_active",
      fn: function (_ref9) {
        var value = _ref9.value;
        return [value ? _c('span', [_vm._v(" Production ")]) : _c('span', [_vm._v(" Testing ")])];
      }
    }, {
      key: "created",
      fn: function (_ref10) {
        var value = _ref10.value;
        return [_c('span', {
          staticClass: "text-sm"
        }, [_vm._v(_vm._s(_vm.formatDate(value).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDate(value).time))])];
      }
    }], null, false, 3183037889)
  }), _c('t-modal-file', {
    ref: "OpenModal"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center relative"
  }, [_c('span', {
    staticClass: "absolute -right-5 -top-6 bg-white rounded-full h-5 w-5 items-center cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.closeX();
      }
    }
  }, [_vm._v(" x ")]), _c('div', {
    staticClass: "relative overflow-x-auto"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center"
  }, [_c('table', {
    staticClass: "table-auto w-full text-sm text-left text-gray-500 dark:text-white"
  }, [_c('thead', {
    staticClass: "text-xs uppercase bg-gray-200 dark:bg-gray-800 dark:text-gray-400"
  }, [_c('tr', [_c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Orderline key")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Price")]), _c('th', {
    staticClass: "px-2 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Discounted Price")])])]), _c('tbody', _vm._l((_vm$modalData = _vm.modalData) === null || _vm$modalData === void 0 ? void 0 : _vm$modalData.orderlines, function (orderline) {
    var _vm$modalData2, _vm$modalData3;
    return _c('tr', {
      key: orderline.id,
      staticClass: "bg-white border-b dark:bg-gray-900 dark:border-gray-700"
    }, [_c('td', {
      staticClass: "px-2 py-4 font-medium text-gray-900 dark:text-white"
    }, [_vm._v(" " + _vm._s(orderline.id) + " ")]), _c('td', {
      staticClass: "px-2 py-4"
    }, [_vm._v(" " + _vm._s(orderline.name) + " ")]), _c('td', {
      staticClass: "px-2 py-4"
    }, [_vm._v(" " + _vm._s(orderline.quantity) + " ")]), _c('td', {
      staticClass: "px-2 py-4"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(orderline.price, (_vm$modalData2 = _vm.modalData) === null || _vm$modalData2 === void 0 ? void 0 : _vm$modalData2.currency_code)) + " ")]), _c('td', {
      staticClass: "px-2 py-4"
    }, [_vm._v(" " + _vm._s(_vm.getDiscountPrice(orderline.price, orderline.final_price, (_vm$modalData3 = _vm.modalData) === null || _vm$modalData3 === void 0 ? void 0 : _vm$modalData3.currency_code, orderline.currency_code, orderline.quantity)) + " ")])]);
  }), 0)])])])]), _c('div', {
    staticClass: "flex justify-center"
  })])], 1) : _c('div', [!_vm.isLoading ? _c('div', {
    staticClass: "relative mt-4 overflow-x-auto my-2 mb-4 rounded-lg border-gray-200 border-b border-t border-r border-l"
  }, [_c('table', {
    staticClass: "min-w-full h-64 text-sm rounded-lg text-left"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "bg-white w-full"
  }, [_c('tr', [_c('td', {
    staticClass: "text-center py-8 text-gray-500",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "flex-col items-center justify-center flex-nowrap flex",
    staticStyle: {
      "height": "574px"
    }
  }, [_c('svg', {
    staticClass: "w-14 h-14 text-gray-500 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"
    }
  })]), _c('h4', {
    staticClass: "text-base text-gray-600 mb-0"
  }, [_vm._v("No Data")]), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("There are no data to display")])])])])])])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "bg-gray-50 text-gray-700"
  }, [_c('tr', {
    staticClass: "text-center uppercase"
  }, [_c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Order Id")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Order Number")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Amount")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("payment gateway")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("renewal type")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("Client")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("ENVIRONMENT")]), _c('th', {
    staticClass: "px-2 py-3 text-center bg-gray-100 border-0 font-semibold upprace uppercase text-xs text-gray-500 border-b"
  }, [_vm._v("transaction Date")])])]);
}]

export { render, staticRenderFns }